import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import { BasicDetailTextField } from '../../../restaurant/settings/styled/BasicDetails.styled'
import {
  selectOnboardDescribeYourselfDetail,
  setOnboardDescribeYourselfDetail,
} from '../../../../store/influencer/contentCreator'
import useAppUtilities from '../../../../hooks/useAppUtilities'
import { OnboardDescribeYourselfMethods } from '../../../../types/contentCreatorTypes'
import { useAppSelector } from '../../../../store'

interface DescribeYourselfStepProps {
  setIsValidData: (isValid: boolean) => void
  readonly?: boolean
}

const DescribeYourselfStep = forwardRef<
  OnboardDescribeYourselfMethods,
  DescribeYourselfStepProps
>(({ setIsValidData, readonly = false }, ref) => {
  const descriptionYourself = useAppSelector(
    selectOnboardDescribeYourselfDetail,
  )
  const [description, setDescription] = useState<string>('')
  const { dispatch } = useAppUtilities()

  useEffect(() => {
    if (descriptionYourself) {
      setDescription(descriptionYourself)
    }
  }, [descriptionYourself])

  useEffect(() => {
    // Fix inverted logic: setIsValidData(true) means form is valid
    // Description must be at least 500 characters
    const isValid = description.length >= 500
    setIsValidData(isValid)
  }, [description, setIsValidData])

  const getPayload = (): string => {
    dispatch(setOnboardDescribeYourselfDetail(description))
    return description
  }

  const resetForm = (): void => {
    setDescription(descriptionYourself)
  }

  useImperativeHandle(ref, () => ({ getPayload, resetForm }))
  return (
    <BasicDetailTextField
      isEditMode={!readonly}
      value={description}
      placeholder="Eg: Who are you and what type of content do you create? Who is your audience etc"
      labelWeight={500}
      setValue={(e) => setDescription(e)}
      ref={ref}
      error={description.length > 0 && description.length < 500}
      helperText={
        description.length > 0 && description.length < 500
          ? 'Please enter at least 500 characters in the description.'
          : ''
      }
    />
  )
})

DescribeYourselfStep.displayName = 'DescribeYourselfStep'

export default DescribeYourselfStep
